(function(angular) {
	'use strict';

	angular.module('xpsui:directives')
	.directive('xpsuiUploadableImageView', ['xpsui:NotificationFactory', function(notificationFactory) {
		return {
			restrict: 'A',
			require: ['?ngModel'],
			scope: true,
			controller: function() {
			},
			link: function(scope, elm, attrs, ctrls) {
				var imgWidth = attrs.psuiWidth || 0;
				var imgHeight = attrs.psuiHeight || 0;

				elm.attr('style', 
					(imgHeight ? 'height:'+imgHeight+'px !important;':'')
				);

				elm.addClass('xpsui-uploadable-image-view');

				var actionsStrip = angular.element('<div class="xpsui-image-actions x-hidden"></div>')
				var downloadButton = angular.element('<button class="btn-primary"><i class="fa fa-save"></i></button>')

				actionsStrip.append(downloadButton)
				elm.append(actionsStrip)


				var ngModel = ctrls[0];
				if (ngModel) {
					ngModel.$render = function() {
						elm.css('background-image', 'url('+(ngModel.$viewValue || 'img/no_photo.jpg')+')');
						ngModel.$viewValue && actionsStrip.removeClass('x-hidden');
					};

				}
				downloadButton.on('click', function(evt) {
					window.open('/photos/download/' + ngModel.$viewValue.substring('/photos/get/'.length), '_blank')
					evt.stopPropagation();
				})
			}
		}
	}]);

}(window.angular));